<template>
  <div class="mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card">
            <div class="d-flex">
              <h3 class="font-weight-light ml-3 mr-auto">{{ getHeaderTitle() }}</h3>
              <WhiteLabel class="ml-auto mt-1 pull-right mr-4">
                <router-link :to="{ name: 'bills-payment' }">
                  <i class="icon-arrow-left-circle"></i> Voltar
                </router-link>
              </WhiteLabel>
            </div>
            <hr />
            <div class="card-content">
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue"> {{ getTitle() }} </h4>
                  </WhiteLabel>
                </div>
                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Agente arrecadador</label>
                  <p>CNC: 341 Banco Itaú S/A</p>
                </div>
                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Código de Barras</label>
                  <p>{{ formatBarcodeForRFB(paymentDetail.barCode) }}</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Data do pagamento</label>
                  <p>{{ paymentDetail.createdAt | moment('DD/MM/YYYY') }}</p>
                </div>
                <div v-if="'0328' == this.getAgreementCode() || '0432' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Número do Documento</label>
                  <p>{{ formatDocumentNumber(getValueOf('DocumentNumber')) }}</p>
                </div>

                <div v-if="'0270' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Competência</label>
                  <p>{{ formatCompetencePeriod(getValueOf('CompetencePeriod')) }}</p>
                </div>
                <div v-if="'0270' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Identificador</label>
                  <p>{{ getValueOf('Identifier') }}</p>
                </div>
                <div v-if="'0270' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Código de Pagamento</label>
                  <p>{{ getValueOf('PaymentCode') }}</p>
                </div>

                <div v-if="'0064' == this.getAgreementCode() || '0153' == this.getAgreementCode()"  class="form-group col-12 col-lg-6 mb-4">
                  <label> Período de Apuração </label>
                  <p>{{ getValueOf('VerificationPeriod') }}</p>
                </div>
                <div v-if="'0064' == this.getAgreementCode() || '0153' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Número do CPF ou CNPJ </label>
                  <p>{{ getValueOf('DocumentNumber') }}</p>
                </div>
                <div v-if="'0064' == this.getAgreementCode() || '0153' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Código da Receita </label>
                  <p>{{ getValueOf('RevenueCode') }}</p>
                </div>
                <div v-if="'0064' == this.getAgreementCode() || '0153' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Data de Vencimento </label>
                  <p>{{ paymentDetail.dueDate | moment('DD/MM/YYYY')}}</p>
                </div>
                <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                  <label>{{ getValueLabel() }}</label>
                  <p>
                    {{
                      paymentDetail.value
                        | currency('R$ ', 2, {
                            decimalSeparator: ',',
                            thousandsSeparator: '.',
                          })
                    }}
                  </p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label> Autenticação </label>
                  <p>{{ getValueOf('OperationCode') }}</p>
                </div>

                <div v-if="'0270' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Transação efetuada em</label>
                  <p>{{ paymentDetail.createdAt | moment('MM/YYYY') }}</p>
                </div>
                <div v-if="'0270' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Às</label>
                  <p>{{ paymentDetail.createdAt | moment('HH:mm:ss') }}</p>
                </div>

                <div v-if="isTypeDARF()" class="form-group col-12 col-lg-6 mb-4">
                  <label></label>
                  <p>MODELO APROVADO PELA SRF - ADE CONJUNTO CORAT/COTEC Nº 001, DE 2006.</p>
                </div>

                <div v-if="'0328' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Pagamento efetuado em </label>
                  <p>{{ paymentDetail.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                </div>

                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Via</label>
                  <p>Internet</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>CTRL</label>
                  <p>{{ getValueOf('ControlNumber') }}</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>NSU</label>
                  <p>{{ getValueOf('Nsu') }}</p>
                </div>
                <div class="form-group col-12">
                  <label class="text-muted">
                    RECEBIDO POR CORRESPONDENTE BANCÁRIO DIGITAL E PROCESSADO POR ITAÚ UNIBANCO S.A.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

export default {
  name: 'AppPaymentDetailsTypeRFB',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value &&
          typeof value.barCode === 'string' &&
          'valuePaid' in value &&
          'preset' in value
        );
      },
    },
  },
  methods: {
    getTitle() {
      let billType = this.agreementCodeType();

      if(billType == 'DAS') return 'Comprovante de Pagamento Simples Nacional';
      if(billType == 'DARF') return 'Comprovante de Pagamento - DARF';
      if(billType == 'GPS') return 'Comprovante de Pagamento - GPS - Guia da Previdência Social';
      if(billType == 'DAE') return 'Documento de Arrecadação do E-Social';

      return '';
    },
    getHeaderTitle() {
      const agreementCode = this.getAgreementCode();
      if (agreementCode === '0270' || agreementCode === '0328' || agreementCode === '0432') {
        return 'Comprovante de Pagamento';
      }
      return 'Pagamento de FGTS';
    },
    getValueLabel() {
      const agreementCode = this.getAgreementCode();
      if (agreementCode === '0270' || agreementCode === '0328' || agreementCode === '0432') {
        return 'Valor Total';
      }
      return 'Valor';
    },
  },
};
</script>
